<template>
  <li class="nav-item" v-if="item.type === 'single' && item.ver === 1">
    <a
      class="nav-link"
      :class="{ 'bg-active': item.active }"
      @click.prevent="$emit('navigate', item.path)"
    >
      <i class="material-icons">{{ item.icon }}</i>
      <p>{{ item.text }}</p>
    </a>
  </li>

  <li class="nav-item" v-else-if="item.type === 'group' && hasVisibleChildren(item)">
    <a
      class="nav-link"
      data-toggle="collapse"
      :href="`#${id}`"
      aria-expanded="false"
      aria-controls="menu"
    >
      <i class="material-icons">{{ item.icon }}</i>
      <p>{{ item.text }} <b class="caret"></b></p>
    </a>

    <div class="collapse" :id="id">
      <ul class="nav">
        <SidebarItem
          v-for="(child, idx) in item.children"
          :key="idx"
          :item="child"
          :id="`${id}-${idx}`"
          @navigate="$emit('navigate', $event)"
        />
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: Object,
    id: String,
  },
  methods: {
    hasVisibleChildren(item) {
      return (
        item.children &&
        item.children.some(
          (child) => (child.type === 'group' || child.type === 'single') && child.ver === 1
        )
      );
    },
  },
};
</script>
